export default __webpack_public_path__ + "static/media/plataforma_fondo1.66cf84bb.png";